/**
 * CAUSA RAIZ CONFIRMADA:
 * O script de reviews do Klaviyo faz um scan único e SÍNCRONO aos
 * `.klaviyo-star-rating-widget` num momento fixo do carregamento da página.
 * Não existe nenhum observador (confirmado: nem MutationObserver, nem
 * re-scan posterior) - testámos reinserir e até clonar os nós, sem efeito.
 *
 * O bloco <product-recommendations> carrega o seu conteúdo via fetch
 * ASSÍNCRONO (endpoint /recommendations/products?...), que por definição
 * só pode responder depois do scan síncrono do Klaviyo já ter passado.
 * Por isso os widgets deste bloco falham SEMPRE, de forma garantida - não
 * é um bug intermitente, é uma corrida estruturalmente perdida.
 *
 * ÚNICA SOLUÇÃO REAL: impedir o script do Klaviyo de correr até o bloco de
 * recomendações já ter terminado de carregar. Este script intercepta a
 * tag <script> do Klaviyo antes de ela executar (mudando o seu `type`
 * para algo que o browser ignora), e só a "liberta" depois de confirmar
 * que o bloco de recomendações já tem a classe `product-recommendations--loaded`
 * (ou, em alternativa, após um limite de tempo de segurança, para não
 * bloquear o Klaviyo indefinidamente se não houver bloco de recomendações
 * nessa página).
 *
 * IMPORTANTE: este script tem de correr e concluir a interceção ANTES do
 * script real do Klaviyo ser parseado pelo browser - por isso tem de ser
 * colocado o mais no topo do <head> possível, antes de qualquer script tag
 * do Klaviyo (o app embed injeta isso via content_for_header).
 */
(function () {
  var MAX_WAIT_MS = 4000; // limite de segurança
  var CHECK_INTERVAL_MS = 100;

  function isKlaviyoScript(node) {
    return node.tagName === 'SCRIPT' &&
      node.src &&
      /klaviyo\.js|static\.klaviyo\.com/i.test(node.src);
  }

  var heldScripts = [];

  // Interceta ANTES da execução: qualquer <script> do Klaviyo que apareça
  // no <head>/<body> é imediatamente neutralizado (type="text/plain" faz
  // o browser ignorá-lo por completo, sem o descarregar/executar).
  var interceptObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && isKlaviyoScript(node) && node.type !== 'text/plain') {
          var clone = document.createElement('script');
          // Copia todos os atributos, exceto o próprio type original
          Array.prototype.forEach.call(node.attributes, function (attr) {
            if (attr.name !== 'type') clone.setAttribute(attr.name, attr.value);
          });
          clone.type = 'text/plain'; // browser ignora, não descarrega nem executa
          node.replaceWith(clone);
          heldScripts.push(clone);
        }
      });
    });
  });
  interceptObserver.observe(document.documentElement, { childList: true, subtree: true });

  function releaseHeldScripts() {
    interceptObserver.disconnect();
    heldScripts.forEach(function (clone) {
      var real = document.createElement('script');
      Array.prototype.forEach.call(clone.attributes, function (attr) {
        if (attr.name !== 'type') real.setAttribute(attr.name, attr.value);
      });
      clone.replaceWith(real); // ao inserir com type normal, o browser executa
    });
    heldScripts = [];
  }

  function recommendationsReady() {
    var blocks = document.querySelectorAll('product-recommendations');
    if (blocks.length === 0) return true; // não há bloco nesta página, não há motivo para esperar
    return Array.prototype.every.call(blocks, function (b) {
      return b.classList.contains('product-recommendations--loaded') || b.dataset.url === undefined;
    });
  }

  var startedAt = Date.now();
  var poll = setInterval(function () {
    var timedOut = (Date.now() - startedAt) > MAX_WAIT_MS;
    if (recommendationsReady() || timedOut) {
      clearInterval(poll);
      releaseHeldScripts();
    }
  }, CHECK_INTERVAL_MS);
})();